import { render } from "./NewAdmin.vue?vue&type=template&id=34b63746&scoped=true"
import script from "./NewAdmin.vue?vue&type=script&lang=js"
export * from "./NewAdmin.vue?vue&type=script&lang=js"

import "./NewAdmin.vue?vue&type=style&index=0&id=34b63746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b63746"]])

export default __exports__